import { render, staticRenderFns } from "./TianDiTuMap.vue?vue&type=template&id=74ead7f1&scoped=true"
import script from "./TianDiTuMap.vue?vue&type=script&lang=js"
export * from "./TianDiTuMap.vue?vue&type=script&lang=js"
import style0 from "./TianDiTuMap.vue?vue&type=style&index=0&id=74ead7f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ead7f1",
  null
  
)

export default component.exports